<template>
  <v-container>
    <h1 class="title">Logout - Esci</h1>
    <v-alert prominent type="error">
      <v-row align="center">
        <v-col class="grow">Si perderanno tutti i dati immessi</v-col>
        <v-col class="shrink">
          <v-btn @click="reset">Logout</v-btn>
        </v-col>
      </v-row>
    </v-alert>
  </v-container>
</template>
<script>
import firebase from "firebase/app";
export default {
  name: "App",
  methods: {
    reset() {
      // this.$store.commit("clearHousehold");
      // this.$router.push("/");
      firebase
        .auth()
        .signOut()
        .then(() => {
          this.$router.replace("/");
        });
    },
  },
  components: {},
  data: () => ({}),
};
</script>
